import { render, staticRenderFns } from "./BtnDownloads.vue?vue&type=template&id=b3923f48&scoped=true&"
import script from "./BtnDownloads.vue?vue&type=script&lang=js&"
export * from "./BtnDownloads.vue?vue&type=script&lang=js&"
import style0 from "./BtnDownloads.vue?vue&type=style&index=0&id=b3923f48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3923f48",
  null
  
)

export default component.exports